import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { LOANDEPOT_SUPPORT_DISPLAY } from '@ld.consumer-portal/constants';
import { PlatformService } from '@ld.consumer-portal/utils';

@Component({
  selector: 'ld-service-unavailable-page',
  imports: [MatButtonModule, TranslocoDirective],
  templateUrl: './service-unavailable-page.component.html',
  styleUrl: './service-unavailable-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceUnavailablePageComponent {
  private readonly transloco = inject(TranslocoService);
  private readonly platformService = inject(PlatformService);

  protected readonly isNativeMobile = this.platformService.isNativeMobile;

  readonly title = input<string>(this.transloco.translate('errorsServiceUnavailableTitle'));

  readonly message = input<string>(this.transloco.translate('errorsServiceUnavailableMessage'));

  readonly phoneNumber = input<string>(LOANDEPOT_SUPPORT_DISPLAY);

  readonly showContactInfo = input<boolean>(true);

  readonly goHome = output<void>();

  readonly refresh = output<void>();

  onGoHome(): void {
    this.goHome.emit();
  }

  onRefresh(): void {
    this.refresh.emit();
  }
}
